import React, { FC } from 'react'
import ActionData from '../../../types/ActionData'
import { Button, Form, Modal } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { CircularProgress } from '@material-ui/core'
import BasicUploadForm from '../../BasicUploadForm'
import { Formik } from 'formik'
import { UploadProviderFileAuditModalSchema } from '../../../utils/validation'

import { mainColors } from '../../../assets/colors'
import './index.css'

interface Props {
  show: boolean;
  modalHeader: string;
  readonly: boolean;
  state: any;
  uploadingDocument: boolean;
  updateProviderFileAuditItem: ActionData;
  onClose: () => void;
  onSubmit: (values: any) => void;
}

const renderModalBody = (modalHeader: string, state: any, errors: any, readonly: boolean, onChange: (key: string, value: Array<File> | boolean) => void) => {
  switch(modalHeader) {
    case 'W-9 In Record':
      return <BasicUploadForm
        key='w9'
        isMulti
        name='w9'
        placeholder='Locate a copy of your W-9'
        files={state.w9}
        uploadedFile={state.w9File}
        error={errors.w9}
        readonly={readonly}
        onChangeFile={onChange}
      />
    case 'Active Certificate/Licensure':
      return <BasicUploadForm
        key='activeCertificateLicensure'
        isMulti
        name='activeCertificateLicensure'
        placeholder='Locate a copy of your active Certificate/Licensure'
        files={state.activeCertificateLicensure}
        uploadedFile={state.activeCertificateLicensureFile}
        error={errors.activeCertificateLicensure}
        readonly={readonly}
        onChangeFile={onChange}
      />
    case 'Active Liability Insurance':
      return <BasicUploadForm
        key='activeLiabilityInsurance'
        isMulti
        name='activeLiabilityInsurance'
        placeholder='Locate a copy of your active liability insurance'
        files={state.activeLiabilityInsurance}
        uploadedFile={state.activeLiabilityInsuranceFile}
        error={errors.activeLiabilityInsurance}
        readonly={readonly}
        onChangeFile={onChange}
      />
    case 'Active Homeowners Insurance':
      return <BasicUploadForm
        key='activeHomeownersInsurance'
        isMulti
        name='activeHomeownersInsurance'
        placeholder='Locate a copy of your active homeowners insurance'
        files={state.activeHomeownersInsurance}
        uploadedFile={state.activeHomeownersInsuranceFile}
        error={errors.activeHomeownersInsurance}
        readonly={readonly}
        onChangeFile={onChange}
      />
    case 'Active Auto Insurance':
      return <BasicUploadForm
        key='activeAutoInsurance'
        isMulti
        name='activeAutoInsurance'
        placeholder='Locate a copy of your active auto insurance'
        files={state.activeAutoInsurance}
        uploadedFile={state.activeAutoInsuranceFile}
        error={errors.activeAutoInsurance}
        readonly={readonly}
        onChangeFile={onChange}
      />
    default:
      return <div>Should not be here</div>
  }
}

const UploadProviderFileAuditModal: FC<Props> = ({ show, modalHeader, readonly, state, uploadingDocument, updateProviderFileAuditItem, onClose, onSubmit }: Props) => {
  const loadingIcon = updateProviderFileAuditItem.loading ? <CircularProgress size={70} /> :
    updateProviderFileAuditItem.error !== false !== false ? <FontAwesomeIcon icon={['fas', 'exclamation-circle']} color={mainColors.loadingBlue} className='modal-success-icon' /> : ''
  const modalText =  updateProviderFileAuditItem.error !== false ? 'The data could not be saved.' : ''

  return (
    <Modal size='lg' show={show} onHide={onClose}>
      <Modal.Header closeButton id='modal-header'>
        <FontAwesomeIcon icon={['fas', 'file-alt']} size='lg' className='modal-header-icon' />
        <Modal.Title id='modal-header-title'>{modalHeader === 'Copy of Facility Licensure' && state.applicationType === 'non-residential' ? 'Copy of Agency Licensure' :modalHeader}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {uploadingDocument ? ( 
          updateProviderFileAuditItem.loading || updateProviderFileAuditItem.error!== false ? (
            <div className='modal-loading-container'>
              {loadingIcon}
              <span className='modal-loading-text' style={updateProviderFileAuditItem.error!== false ? {width: '100%'} : {}}>
                {modalText}
                {
                  updateProviderFileAuditItem.error!== false ? (<span style={{width: '100%'}} dangerouslySetInnerHTML={{__html: updateProviderFileAuditItem.error.response ? updateProviderFileAuditItem.error.response.text : '' }} />) : null
                }
              </span>
            </div>
          ) : updateProviderFileAuditItem.success ? (
            <div>
              <div className='modal-success-container'>
                <FontAwesomeIcon icon={['far', 'check-circle']} color={mainColors.successGreen} className='modal-success-icon' />
                <span className='modal-loading-text'>Success!</span>
                <span className='modal-success-text'>You have submitted a document.</span>
              </div>
            </div>
          ) : (
            <div></div>
          )
        ) : (
          <Formik
            initialValues={state}
            enableReinitialize
            validationSchema={UploadProviderFileAuditModalSchema}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(false)
              onSubmit(values)
            }}
          >
            {({
              values,
              errors,
              handleSubmit,
              setFieldValue,
            }) => {
              return (
                <Form noValidate onSubmit={handleSubmit}>
                  {
                    renderModalBody(modalHeader, values, errors, readonly, setFieldValue)
                  }
                  <div style={{ display: 'flex', marginTop: 15, justifyContent: 'center' }}>
                    <Button
                      variant='secondary'
                      className='mr-2 custom-button'
                      onClick={onClose}
                    >
                        Cancel
                    </Button>
                    {!readonly && (
                      <Button
                        variant='info'
                        className='custom-button'
                        type='submit'
                      >
                          Submit
                      </Button>
                    )}
                  </div>
                </Form>
              )
            }}
          </Formik>
        )}
        
      </Modal.Body>
    </Modal>
  )
}

export default UploadProviderFileAuditModal